interface PlusIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export default function PlusIcon(props: PlusIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={43.884}
      height={43.884}
      viewBox="0 0 43.884 43.884"
      {...props}>
      {props.title && <title>{props.title}</title>}
      <path
        data-name="Icon ionic-ios-add"
        d="M41.152 19.21H24.674V2.735a2.732 2.732 0 10-5.464 0V19.21H2.735a2.732 2.732 0 000 5.464H19.21v16.478a2.732 2.732 0 105.464 0V24.674h16.478a2.732 2.732 0 100-5.464z"
      />
    </svg>
  )
}
